<template>
  <div id="confirm" class="container">
    <div class="row">
      <div class="col">
        <h1>Confirme os dados do solicitador</h1>
      </div>
    </div>
    <div id="data_user" class="row justify-content-md-center">
      <div class="col-md-auto">
        <div class="card">
          <img
            class="card-img-top"
            :src="image"
            alt="Foto do Solicitador"
            v-if="image != null"
          />
          <div class="card-body">
            <p class="card-text" v-if="name != null">
              {{ name }}
              <br />
              {{ phone }}
            </p>
            <div v-else>
              <p>
                Bem vindo a Urb, digite seu nome:
              </p>
              <input
                v-model="name_auth"
                type="text"
                id="input_name"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>Deseja liberar o acesso a sua conta via API?</p>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-auto">
        <div class="row">
          <div class="col">
            <button
              id="button_no"
              class="btn btn-secondary"
              type="button"
              v-on:click="signOut"
            >
              Não
            </button>
          </div>
          <div class="col">
            <button
              id="button_yes"
              class="btn btn-dark"
              type="button"
              v-on:click="redirectToCallback"
            >
              Sim
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions, auth } from "./../configs/firebase.js";

export default {
  name: "Confirm",
  data() {
    return {
      image: null,
      name: "",
      phone: null,
      name_auth: "",
    };
  },
  methods: {
    async signOut() {
      await auth.signOut();
    },
    async redirectToCallback() {
      this.$root.loading = true;

      if (this.name == null) {
        if (this.name_auth.length < 3) {
          this.$root.loading = false;
          alert("Seu nome deve conter pelo menos 3 letras");
          return;
        }

        if (this.name_auth.split(" ").length < 2) {
          this.$root.loading = false;
          alert("Você deve inserir também um sobrenome");
          return;
        }

        this.name_auth = this.name_auth
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        await this.user.updateProfile({
          displayName: this.name_auth,
        });
      }

      let snapShotApi = await db.ref("api/" + this.user.uid).once("value");
      let data = snapShotApi.val();

      if (data == null || data.key == null || data.key_secret == null) {
        let timestamp = new Date().getTime();
        let base0 = this.user.uid + timestamp.toString();
        let key = new Buffer.from(base0).toString("base64");
        let base1 = timestamp.toString() + this.user.uid;
        let keySecret = new Buffer.from(base1).toString("base64");

        data = { key: key, key_secret: keySecret };
        await db.ref("api/" + this.user.uid).set(data);
      }

      this.$root.key = data.key;
      this.$root.key_secret = data.key_secret;
      this.$root.isRedirect = true;

      await this.signOut();
    },
  },
  computed: {
    user: function() {
      return this.$root.user;
    },
  },
  created() {
    this.$root.loading = true;
  },
  async mounted() {
    if (
      this.$root.public_key == null ||
      this.$root.callback == null ||
      this.$root.external == null ||
      this.$root.external.length < 1
    ) {
      await this.signOut();
    } else {
      let checkUserByApiKey = functions.httpsCallable("checkUserByApiKey");
      let result = await checkUserByApiKey({
        key: this.$root.public_key
      });

      if (typeof result.data !== "string") {
        this.name = result.data.displayName;
        this.image = result.data.photoURL;
        this.phone = result.data.phoneNumber;
      } else {
        await this.signOut();
      }
      
    }

    this.$root.loading = false;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#data_user {
  margin: 20px;
}
</style>
